export enum ColumnType {
    Fn,
    FnArgument,
    Parameter,

    Error,
    Iterations,
    Max,
    Mean,
    Median,
    Min,
    Ops,
    Q1,
    Q3,
    StdDev,
    StdErr,

    CIErrorL50,
    CIErrorL70,
    CIErrorL75,
    CIErrorL80,
    CIErrorL85,
    CIErrorL90,
    CIErrorL92,
    CIErrorL95,
    CIErrorL96,
    CIErrorL97,
    CIErrorL98,
    CIErrorL99,
    CIErrorL999,
    CIErrorL9999,
}
